import { render, staticRenderFns } from "./InboundReplicationInfo.vue?vue&type=template&id=b3c18776&"
import script from "./InboundReplicationInfo.vue?vue&type=script&lang=js&"
export * from "./InboundReplicationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3c18776')) {
      api.createRecord('b3c18776', component.options)
    } else {
      api.reload('b3c18776', component.options)
    }
    module.hot.accept("./InboundReplicationInfo.vue?vue&type=template&id=b3c18776&", function () {
      api.rerender('b3c18776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/InboundReplicationInfo.vue"
export default component.exports